module.exports = __webpack_public_path__ + "static/img/fa-nv@2x.480cc6af.png";